<script type="text/javascript">

    import TextareaAutosize from '../global/form/TextareaAutosize.vue';
    import OccupationSelect from '../global/form/OccupationSelect';
    import { http } from 'App/http';

    export default {
        created() {
            this.USER_RATE_STEP = 1;
            this.USER_OCCUPATION_STEP = 2;
            this.USER_DESCRIPTION_STEP = 3;
        },

        data() {
            return {
                description: '',
                chosen_rating: null,
                step: null,
                occupation: '',
                formErrors: [],
            }
        },

        props: {
            hasOccupation: {
                required: true,
                type: Boolean,
            },
            isEmployee: {
                required: true,
                type: Boolean,
            },
        },

        mounted() {
            this.step = this.USER_RATE_STEP;
            $('#feedback-modal').modal({
                backdrop: 'static',
                keyboard: false
            });

            $('#feedback-modal').modal('show');
        },

        methods: {
            rate(rating) {
                this.chosen_rating = rating;

                http.post('/app/feedback', { rating : this.chosen_rating } )
                    .then(({ data }) => {
                        this.step = this.hasOccupation && !this.isEmployee ? this.USER_DESCRIPTION_STEP : this.USER_OCCUPATION_STEP;
                    })
                    .catch(({ error, errorBag }) => {
                        if (errorBag) {
                            this.$setErrorBag(errorBag);
                        }
                    });
            },
            next() {
                http.post('/app/feedback/updateOccupation', { occupation: this.occupation })
                    .then(() => { this.formErrors = []; this.step = this.USER_DESCRIPTION_STEP; })
                    .catch((e) => {this.formErrors = e.error.response.data;});
            },
            finish() {
                this.close();
                this.saveDescription();

                let succes_text = trans('feedback.success');

                if (this.chosen_rating > 7) {
                    succes_text = '<i class="zmdi zmdi-thumb-up m-r-5"></i> ' + succes_text;
                }

                toastr.success(succes_text);
            },
            close() {
                $('#feedback-modal').modal('hide');
            },
            delay() {
                http.post('/app/feedback/delay', { } )
                    .then(({ data }) => {
                        this.close();
                    })
                    .catch(({ error, errorBag }) => {
                        if (errorBag) {
                            this.$setErrorBag(errorBag);
                        }
                    });
            },
            neverShowAgain() {
                http.post('/app/feedback/never-show-again', { } )
                    .then(({ data }) => {
                        this.close();
                    })
                    .catch(({ error, errorBag }) => {
                        if (errorBag) {
                            this.$setErrorBag(errorBag);
                        }
                    });
            },
            saveDescription() {
                if(this.description !== ''){
                    http.post('/app/feedback/description', { description: this.description })
                        .then((resp) => { console.log(resp); })
                        .catch((e) => { console.log(e)});
                }
            }
        },

        computed: {

            isAspitUser() {
                return ['physica', 'psykbase'].includes(this.$store.state.brand);
            },

        },
        components: { TextareaAutosize, OccupationSelect },
    };


</script>


<template id="feedback">
    <div class="modal-dialog customer-feedback">
        <div class="panel panel-color panel-inverse m-0">
            <div class="panel-heading">
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="modal-content ">

            <div class="modal-body p-0">

                <div class="text-center">

                    <div v-if="step == USER_RATE_STEP" class="m-b-30 text-center">
                        <h3 class="m-b-30 m-l-10 m-r-10">{{ trans('feedback.question') }}</h3>
                       <div class="customer-feedback-rating-wrapper">
                           <a href="" class="btn btn-default" @click.prevent="rate(1)">1</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(2)">2</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(3)">3</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(4)">4</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(5)">5</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(6)">6</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(7)">7</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(8)">8</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(9)">9</a>
                           <a href="" class="btn btn-default" @click.prevent="rate(10)">10</a>
                           <div class="row m-t-10">
                               <div class="col-xs-6 text-left">{{ trans('feedback.not_likely') }} </div>
                               <div class="col-xs-6 text-right">{{ trans('feedback.likely') }}</div>
                           </div>
                       </div>
                    </div>

                    <div v-if="step == USER_OCCUPATION_STEP" class="m-b-20">
                        <h3 class="m-b-10 m-l-10 m-r-10">{{ trans('feedback.what_is_your_occupation') }}</h3>
                        <OccupationSelect v-model="occupation" selectstyle="multiselect"/>
                        <small class="text-small text-danger float-left" v-if="Object.keys(formErrors).length && Object.keys(formErrors).includes('occupation')">
                            {{ formErrors['occupation'][0] }}
                        </small>
                    </div>

                    <div v-if="step == USER_DESCRIPTION_STEP" class="m-b-20">
                        <h3 class="m-b-10 m-l-10 m-r-10">{{ trans('feedback.last_question') }}</h3>
                        <div >
                            <p>{{ trans('feedback.missing') }}</p>
                            <textarea-autosize rows="3" class="form-control" v-model="description" :placeholder="trans('feedback.placeholder')"></textarea-autosize>
                        </div>
                        <div class='text-center m-t-20'>
                            <small>{{ trans('feedback.sensitive_info_warn') }}</small>
                        </div>
                    </div>

                    <div class="customer-feedback-explanation-wrapper">
                        <small v-if='!isAspitUser' class="text-muted">{{ trans('feedback.explanation') }}</small>
                        <small v-else class="text-muted">{{ trans('feedback.aspit_user_explanation') }}</small>
                    </div>

                    <div v-if="step == USER_RATE_STEP && !isAspitUser" class="text-center customer-feedback-secondary-actions m-t-20">
                        <small>
                            <a href="" class="text-muted" @click.prevent="delay" >{{ trans('feedback.delay') }}</a>&nbsp; &nbsp;
                            <a href="" class="text-muted" @click.prevent="neverShowAgain">{{ trans('feedback.never_show_again') }}</a>
                        </small>
                    </div>

                    <div class="m-t-20" v-if="[USER_OCCUPATION_STEP, USER_DESCRIPTION_STEP].includes(step)">
                        <a v-if="step == USER_OCCUPATION_STEP" href="" @click.prevent="next" class="btn btn-custom">{{ trans('global.continue') }} <i class="zmdi zmdi-arrow-right m-r-5"></i></a>
                        <a v-if="step == USER_DESCRIPTION_STEP" href="" @click.prevent="finish" class="btn btn-custom"><i class="zmdi zmdi-check m-r-5"></i> {{ trans('feedback.finish') }}</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
